export const esp = {
  about1:
    'Con el advenimiento de la ciencia, la tecnología, los nuevos dispositivos, las herramientas y los libros, siguen teniendo una gran demanda. Sin embargo, encontrar el libro adecuado en Barcelona no siempre se convierte en una tarea fácil.',
  about2:
    'Aunque existen muchas editoriales y librerías en España, existe una demanda insatisfecha de algunas categorías de libros en nuestro país.',
  about3:
    'Nuestro objetivo es recoger la literatura de nuestras editoriales publicada en el extranjero en un solo lugar de nuestra librería en línea, que es muy demandada en España. Esto debería facilitar mucho la búsqueda de los documentos necesarios, lo que ayudará a los clientes a ahorrar tiempo y dinero.',
  about4:
    'Estamos constantemente investigando la demanda: desarrollando las secciones y categorías relevantes de nuestra librería en línea.',
  about5:
    'Nuestro objetivo es también promover la venta exitosa de libros publicados por editoriales y autores, colocándolos lo más amplios posible para el público en general.',
  a_z: 'A-Z',
  aboutShop: 'Sobre la tienda',
  acc: 'Cuenta',
  accessWith: 'Acceso rápido con',
  account: 'mi cuenta',
  addComment: 'Añadir comentarios',
  addToCart: 'Añadir',
  adventure: 'aventuras',
  alreadyLoggedIn: 'Ya ha iniciado sesión con éxito',
  author: 'autor',
  authors: 'autores',
  authorBooks: 'libros de autor',
  barcelona: 'Barcelona',
  basket: 'cesta',
  book: 'libro',
  booklyTeam: 'Equipo de Bookly',
  buy: 'comprar',
  architecture: 'Arquitectura',
  art: 'Arte',
  adventures: 'Aventuras',
  aboutUs: 'Sobre nosotros',
  bestsellers: 'Bestsellers',
  bestseller: 'bestsellers',
  biography: 'Biografía',
  bookName: 'nombre del libro',
  books: 'libros',
  classics: 'Clásicos',
  classic: 'clásicos',
  cancel: 'cancelar',
  comments: 'comentarios',
  confirmEmail: 'Confirme su dirección de correo',
  confirmEmailPleas:
    'Hemos enviado una carta a su correo electrónico, confirme su correo electrónico.',
  confirmation: 'confirmación',
  confirmed: 'confirmado',
  contacts: 'contactos',
  contactUs: 'Contacta con nosotros',
  copied: 'copiado',
  children: 'NIÑOS',
  children_educational: 'educativo para niños',
  count: 'Cantidad',
  c: 'c',
  c_plus_plus: 'c++',
  c_sharp: 'c#',
  css: 'CSS',
  default: 'defecto',
  delete: 'eliminar',
  deleteComment: '¿Eliminar este comentario?',
  delivery: 'Entrega',
  deliveryText1:
    'En caso de comprar un libro en una tienda online, se entregará gratuitamente a la dirección indicada en el formulario de compra en un plazo de 24 horas, si se encuentra dentro de la ciudad de Barcelona. En todos los demás casos, puede verificar los términos y condiciones de entrega comunicándose con nuestro operador.',
  description: 'descripción',
  detectives: 'Detectives',
  detective: 'detective',
  dictionaries: 'Diccionarios',
  dictionarie: 'diccionarios',
  dramaturgy: 'Dramaturgia',
  economy: 'Economía',
  educational: 'EDUCATIVO',
  educationalCh: 'Educativo',
  email: 'Correo',
  emailNotCorrect: 'Correo no correcto',
  emailorPasswordIsIncorrect: 'Correo o la contraseña son incorrectos',
  emailRequired: 'correo es requerido',
  emailExist: 'Este correo ya está registrado',
  encyclopedias: 'Enciclopedias',
  encyclopedia: 'enciclopedias',
  fables: 'Fábulas',
  fable: 'fábulas',
  fantasy: 'Fantasía',
  fieldIsRequiered: 'Se requiere campo',
  firstName: 'nombre',
  firstNameRequired: 'Se requiere el nombre',
  folklore: 'Folklore',
  forAuthors: 'Para los autores',
  forAuthorsText1:
    'Al colaborar con la tienda en línea Bookly, los autores tendrán la oportunidad de:',
  forAuthorsText2:
    'La tienda en línea Bookly permite a todos los autores vender cualquier libro bajo los términos de cooperación con la tienda. Aseguramos por todos los medios la máxima visibilidad de sus ofertas en Internet.',
  forAuthorsText3:
    'Creamos páginas separadas para todos los autores que colaboran con nosotros, donde se presentan sus sugerencias. Brindamos la oportunidad de publicar información sobre el autor en esta página, para publicar extractos proporcionados por nosotros de trabajos publicados o traducidos en el pasado y en el futuro cercano, reseñas, anuncios sobre ellos, así como cualquier otra información relacionada con el autor. trabajar en el campo de la literatura.',
  forAuthorsText4:
    'Nuestro sitio es una plataforma que permite a los autores y editores colaborar de forma eficaz. Con esta función, puede obtener información detallada sobre los trabajos de impresión que le interesan en línea, lo que le ahorrará mucho tiempo.',
  forAuthorsText5:
    'En las páginas del sitio puede familiarizarse con las reseñas y opiniones de nuestros visitantes sobre su trabajo. Si lo desea, comuníquese con el lector.',
  forAuthorsText6:
    'Si lo desea, tendrá la oportunidad de familiarizarse con algunas de las estadísticas relacionadas con la demanda publicadas en el sitio web. Obtenemos esta información como resultado del estudio de las acciones de los visitantes del sitio, su demanda, opiniones, quejas / sugerencias.',
  forPublishinghouses: 'for publishing houses',
  forPublishersText1:
    'Al convertirse en nuestro socio, tendrá la oportunidad de:',
  forPublishersText2:
    'La tienda en línea Bookly le permite vender libros publicados por usted, de acuerdo con los términos de cooperación con la tienda. Aseguramos por todos los medios la máxima visibilidad de sus ofertas en Internet.',
  forPublishersText3:
    'Para todas nuestras editoriales, proporcionamos páginas separadas que brindan información sobre usted, sus ofertas de venta y otra información relacionada con la actividad, lo que facilitará en gran medida una mayor comunicación comercial con los autores u otras partes interesadas que lo soliciten a través de nuestro sitio.',
  forPublishersText4:
    'Nuestro sitio es una plataforma que permite a los editores, autores, empresas y otras partes interesadas colaborar de manera eficaz. Aprovechando esta oportunidad, puedes recibir diferentes tipos de ofertas y pedidos online.',
  forPublishersText5:
    'Tendrá la oportunidad de publicar anuncios sobre los próximos libros, anuncios, reseñas y otra información, de forma gratuita y de pago.',
  forPublishersText6:
    'Se proporcionará una página separada para todos los libros a la venta, donde se publicará información detallada sobre los mismos, lo que garantizará su máxima visibilidad en Internet.',
  forPublishersText7:
    'Si lo desea, tendrá la oportunidad de familiarizarse con algunas de las estadísticas relacionadas con la demanda publicadas en el sitio web. Obtenemos esta información como resultado del estudio de las acciones de los visitantes del sitio, su demanda, opiniones, quejas / sugerencias.',
  forTeens: 'Para los adolescentes',
  forTeen: 'para los adolescentes',
  gameBooks: 'Libros de juegos',
  gameBook: 'libros de juegos',
  genre: 'género',
  goToHome: 'Ir a Principal',
  hello: 'hola',
  history: 'Historia',
  home: 'principal',
  html: 'HTML',
  imaginative: 'FICCIÓN',
  image: 'imagen',
  it_and_programing: 'TI y Programación',
  java: 'java',
  javascript: 'javascript',
  jurisprudence: 'Jurisprudencia',
  kotlin: 'kotlin',
  language: 'idioma',
  languages: 'Idiomas',
  lastName: 'apellido',
  lastNameRequired: 'Se requiere apellido',
  liked: 'Apreciado',
  likedList: 'Lista enlazada',
  lookLost: 'Parece que estás perdido',
  locationName: 'Barcelona, Cataluña, España',
  manuals: 'Manuales',
  manual: 'manuales',
  medicine: 'Medicina',
  militaryScience: 'Ciencia militar',
  moreComments: 'Más comentarios',
  mostViewed: 'mas visto',
  musical: 'Musical',
  myAccount: 'mi cuenta',
  myBooks: 'mis libros',
  myOrders: 'Mis pedidos',
  new: 'nuevo',
  noBooks: 'Aún no hay libros en esta categoría.',
  noComments: 'Todavía no hay comentarios',
  noOrders: 'Aún no hay pedidos',
  noResultsFound: 'No hay resultados',
  novels: 'Novelas',
  novel: 'novelas',
  onlyUsersComment: 'Solo los usuarios registrados pueden comentar libros.',
  onlyUsersLike: 'Solo los usuarios registrados pueden gustar los comentarios.',
  onlyUsersRate: 'Solo los usuarios registrados pueden calificar libros.',
  orderPlaced: 'pedido realizado',
  orders: 'Pedidos',
  ordersHistory: 'Orders History',
  others: 'OTHERS',
  other: 'otros',
  other_other: 'Mas otros',
  ourAuthors: 'nuestros autores',
  ourPublishers: 'nuestros editores',
  othersOthers: 'Otros',
  pageNoteAvailable: '¡La página que busca no está disponible!',
  pagesCount: 'recuento de páginas',
  password: 'contraseña',
  passwordMore4: 'La contraseña debe tener más 4 símbolos',
  passwordConfirmMore4:
    'La repetición de la contraseña debe tener más de 4 símbolos',
  passwordRequired: 'se requiere contraseña',
  passwordConfirm: 'repite la contraseña',
  passwordConfirmRequired: 'Se requiere repetir la contraseña',
  passwordsNotMatch: 'Contraseñas no coincidentes',
  payment: 'pago',
  personalInformation: 'informacion personal',
  payWithCard: 'pagar con tarjeta',
  philosophy: 'Filosofía',
  php: 'PHP',
  psychology: 'Psicología',
  poems: 'Poemas',
  poem: 'poemas',
  politics: 'Política',
  politic: 'política',
  popular: 'Popular',
  preschool: 'Preescolar',
  price: 'Precio',
  priceLowtoHigh: 'precio: de menor a mayor',
  priceHightoLow: 'precio: de mayor a menor',
  prose: 'Prosa',
  publicism: 'Publicismo',
  publisher: 'editor',
  publishers: 'editores',
  publisherBooks: 'libros de la editorial',
  pyton: 'pyton',
  rate: 'clasificación',
  registerAccount: 'inscribirse',
  registrate: 'registrate',
  religious: 'Religioso',
  return: 'Religioso',
  returnText1:
    'El comprador tiene derecho a devolver o cambiar cualquier producto impreso adquirido en la librería online, si no han transcurrido más de 14 días desde el momento de la compra, si sus propiedades de consumidor, se han conservado la calidad, documento acreditativo de la compra.',
  returnText2:
    '-Si el libro comprado es de mala calidad, tiene un error de impresión u otro daño.',
  returnText3:
    '-Si el producto solicitado no se corresponde con la descripción mencionada en el sitio web.',
  returnText4: 'El producto no será devuelto si ha sido usado o dañado.',
  riddles: 'Acertijos',
  riddle: 'acertijos',
  quantity: 'cantidad',
  rememberPassword: 'recordar contraseña',
  save: 'ahorrar',
  search: 'Buscar',
  searchResults: 'Resultados de la búsqueda',
  services: 'servicios',
  settings: 'ajustes',
  shippingAddress: 'Dirección de Envío',
  sortBy: 'Ordenar por',
  suggestions: 'sugerencias',
  signIn: 'Iniciar sesión',
  signOut: 'desconectar',
  signUp: 'Inscribirse',
  scientific: 'Científico',
  swift: 'swift',
  tales: 'Cuentos',
  tale: 'cuentos',
  telephone: 'teléfono',
  telephoneNotCorrect: 'Teléfono no correcto',
  telephoneRequired: 'Se requiere telefono',
  textbook: 'Libro de texto',
  totalPrice: 'precio total',
  tourism: 'Turismo',
  typescript: 'typescript',
  update: 'actualizar',
  upTo10Years: 'Hasta 10 años',
  upTo10Year: 'hasta 10 años',
  z_a: 'Z-A',
  year: 'año',
  yourBasketIsEmpty: 'Tu canasta esta vacía',
}
